import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AiUsagePage, type UsagePeriod } from '../../../features/B6/ai-usage-page';

const Search = z.object({
  period: z.enum(['day', 'week', 'month']).optional().catch(undefined),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional().catch(undefined),
});

// Settings → "שימוש ב-AI" (D-96) — AI calls, tokens and cost by day / week / month.
export const Route = createFileRoute('/_app/settings/ai')({
  validateSearch: (s) => Search.parse(s),
  component: AiUsageTab,
});

function AiUsageTab() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AiUsagePage
      period={(search.period as UsagePeriod | undefined) ?? 'month'}
      date={search.date}
      setSearch={(p) => void navigate({ search: (prev) => ({ ...prev, ...p }), replace: true })}
    />
  );
}
